/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/
import {
  AfterViewInit, Directive, Input, OnDestroy,
} from '@angular/core';
import { Tooltip } from 'primeng/tooltip';

/**
 * Directive for adding tooltips to components, tags, etc.
 *
 * The implementation uses PrimeNG tooltip.  We currently only expose the text and the position properties, although
 * the PrimeNG tooltip has many other properties which we can add in the future if we need to.
 */
@Directive({
  selector: '[aeroTooltip]',
  standalone: false,
})
export class AeroTooltipDirective extends Tooltip implements AfterViewInit, OnDestroy {
  /**
   * The text to display in the tooltip.
   *
   * @param value The text to display in the tooltip.
   */
  @Input('aeroTooltip') content: string;

  /**
   * Specifies where in relation to the host element the tooltip should be displayed.
   * The options are: 'top', 'right', 'left', and 'bottom'.
   *
   * @param value Where the tooltip is to be displayed.
   */
  @Input('aeroTooltipPosition') tooltipPosition: string;

  /**
   * Overrides the default style class for the tooltip.
   *
   * @param value Name of the class to use for styling.
   */
  @Input('aeroTooltipStyleClass') tooltipStyleClass: string;

}
